import { style } from "@vanilla-extract/css";

export const containerStyle = style({
  transformOrigin: "bottom center",
});
